import React from "react";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import Perfil2 from "./Perfil2";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Loading from "./Loading";
import { escalarImagen } from "../../../resources/Helper";

function Configuracion(props) {

    const [client, setClient] = useState([]);
    const [loggedIn, setLoggedIn] = useState();
    const [loading, setLoading] = useState(false);
    const [duracionCita, setDuracionCita] = useState();
    const [errorlist, setErrorlist] = useState({});

    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState('');

    // Estados para encabezado personalizado
    const [encabezado, setEncabezado] = useState({
        nombre_encabezado: '',
        izquierda: '',
        centro: '',
        derecha: '',
        estado: 1
    });
    const [loadingEncabezado, setLoadingEncabezado] = useState(false);
    const [encabezadoExiste, setEncabezadoExiste] = useState(false);

    // Estados para imágenes de cada columna
    const [imagenIzquierda, setImagenIzquierda] = useState('');
    const [imagenCentro, setImagenCentro] = useState('');
    const [imagenDerecha, setImagenDerecha] = useState('');

    // Estados para tamaños de imagen personalizados
    const [tamañoImagenIzquierda, setTamañoImagenIzquierda] = useState('normal');
    const [tamañoImagenCentro, setTamañoImagenCentro] = useState('normal');
    const [tamañoImagenDerecha, setTamañoImagenDerecha] = useState('normal');

    // Estados para editores de texto simples
    const [contenidoIzquierda, setContenidoIzquierda] = useState('');
    const [contenidoCentro, setContenidoCentro] = useState('');
    const [contenidoDerecha, setContenidoDerecha] = useState('');

    // Referencias para los editores de texto
    const editorIzquierdaRef = useRef(null);
    const editorCentroRef = useRef(null);
    const editorDerechaRef = useRef(null);

    // Referencias para canvas de cada columna
    const canvasIzquierdaRef = useRef(null);
    const canvasCentroRef = useRef(null);
    const canvasDerechaRef = useRef(null);

    // Estado para controlar si los editores están listos
    const [editoresReady, setEditoresReady] = useState(false);

    // Estado para controlar la pestaña activa
    const [activeTab, setActiveTab] = useState('perfil');

    let userdata = [];
    let clientData = [];



    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setLoggedIn(true);
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });


        axios.get('/perfil?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    //setNombre(response.data.name+' '+response.data.lastname);
                    setDuracionCita(response.data.duracion_cita);
                }
            })
            .catch(error => {
                console.log(error);
            });

        // Cargar encabezado personalizado si existe
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data) {
                    const encabezadoData = {
                        nombre_encabezado: response.data.nombre_encabezado || '',
                        izquierda: response.data.izquierda || '',
                        centro: response.data.centro || '',
                        derecha: response.data.derecha || '',
                        estado: response.data.estado || 1
                    };
                    setEncabezado(encabezadoData);
                    setEncabezadoExiste(true);

                    // Actualizar contenido de editores
                    setContenidoIzquierda(encabezadoData.izquierda);
                    setContenidoCentro(encabezadoData.centro);
                    setContenidoDerecha(encabezadoData.derecha);
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    console.log('No hay encabezado personalizado configurado - inicializando formulario vacío');
                } else {
                    console.log('Error Al Cargar Encabezado Personalizado:', error);
                }
                // Siempre inicializar con valores vacíos para mostrar el formulario
                setEncabezado({
                    nombre_encabezado: '',
                    izquierda: '',
                    centro: '',
                    derecha: '',
                    estado: 1
                });
                setEncabezadoExiste(false);
            });

        // Marcar editores como listos después de un pequeño delay
        setTimeout(() => {
            setEditoresReady(true);
        }, 500);
    }, []);



    const handleSubmitParametrosAgenda = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            uid: userdata.user_id,
            duracion_cita: duracionCita
        }

        axios.put('perfil', conf)
            .then(
                response => {
                    setLoading(false);
                    if (response.status === 200) {
                        setShowToast(true);
                        userdata.step = duracionCita;
                        localStorage.setItem('userdata', JSON.stringify(userdata));
                    }

                    //setMensajePopup('Se han guardado los cambios');
                    //setClaseMensajePopup('alert alert-success mensaje-popup visible');
                    //setTimeout(() => setClaseMensajePopup('alert alert-success mensaje-popup'),2000);
                }
            )
            .catch(
                err => {
                    console.log(err);
                    setLoading(false);
                }
            )
    }


    const handleSubmitEncabezado = (e) => {
        e.preventDefault();
        setLoadingEncabezado(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        };

        // Asegurar que client_id sea un número válido
        const clientId = client && client.id ? parseInt(client.id) : 1;

        const data = {
            uid: userdata.user_id,
            client_id: clientId,
            ...encabezado
        };

        // Validación antes de enviar
        if (!data.nombre_encabezado || data.nombre_encabezado.trim() === '') {
            setLoadingEncabezado(false);
            setToastMsg('El Nombre Del Encabezado Es Requerido');
            setShowToast(true);
            return;
        }

        console.log('🔧 Datos a enviar:', data);
        console.log('🔧 Cliente ID:', clientId);
        console.log('🔧 Usuario ID:', userdata.user_id);

        const url = encabezadoExiste ? '/encabezado-personalizado' : '/encabezado-personalizado';
        const method = encabezadoExiste ? 'put' : 'post';

        axios[method](url, data, config)
            .then(response => {
                setLoadingEncabezado(false);
                if (response.status === 200 || response.status === 201) {
                    setShowToast(true);
                    setToastMsg('Encabezado Personalizado Guardado Exitosamente');
                    setEncabezadoExiste(true);
                }
            })
            .catch(err => {
                console.log('❌ Error completo:', err);
                console.log('❌ Error response:', err.response);
                if (err.response && err.response.data) {
                    console.log('❌ Error data:', err.response.data);
                    if (err.response.data.errors) {
                        // Mostrar errores de validación específicos
                        const errores = Object.values(err.response.data.errors).flat().join(', ');
                        setToastMsg('Errores de validación: ' + errores);
                    } else {
                        setToastMsg('Error Al Guardar El Encabezado Personalizado');
                    }
                } else {
                    setToastMsg('Error Al Guardar El Encabezado Personalizado');
                }
                setLoadingEncabezado(false);
                setShowToast(true);
            });
    };

    const handleEncabezadoChange = (field, value) => {
        setEncabezado(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Funciones para aplicar colores al texto seleccionado - VERSIÓN SIMPLE QUE FUNCIONA
    const aplicarColor = (columna, color) => {
        let editorRef = null;
        if (columna === 'izquierda') {
            editorRef = editorIzquierdaRef.current;
        } else if (columna === 'centro') {
            editorRef = editorCentroRef.current;
        } else if (columna === 'derecha') {
            editorRef = editorDerechaRef.current;
        }

        if (editorRef) {
            editorRef.focus();

            // Obtener texto seleccionado
            const selection = window.getSelection();
            const selectedText = selection.toString();

            if (selectedText && selectedText.length > 0) {
                // Hay texto seleccionado - aplicar color
                document.execCommand('foreColor', false, color);
            } else {
                // No hay selección - insertar texto con color
                const textoColoreado = `<span style="color: ${color};">Texto con color</span>&nbsp;`;
                document.execCommand('insertHTML', false, textoColoreado);
            }

            // Actualizar el estado
            const nuevoContenido = editorRef.innerHTML;
            handleEncabezadoChange(columna, nuevoContenido);
        }
    };

    // Funciones para aplicar formato de texto
    const aplicarFormato = (columna, comando) => {
        let editorRef = null;
        if (columna === 'izquierda') {
            editorRef = editorIzquierdaRef.current;
        } else if (columna === 'centro') {
            editorRef = editorCentroRef.current;
        } else if (columna === 'derecha') {
            editorRef = editorDerechaRef.current;
        }

        if (editorRef) {
            editorRef.focus();
            document.execCommand(comando, false, null);

            // Actualizar el estado
            const nuevoContenido = editorRef.innerHTML;
            handleEncabezadoChange(columna, nuevoContenido);
        }
    };

    // Handlers para cambios en los editores
    const handleContenidoChange = (columna, contenido) => {
        if (columna === 'izquierda') {
            setContenidoIzquierda(contenido);
        } else if (columna === 'centro') {
            setContenidoCentro(contenido);
        } else if (columna === 'derecha') {
            setContenidoDerecha(contenido);
        }
        handleEncabezadoChange(columna, contenido);
    };

    // Sincronizar contenido de editores manualmente para evitar salto de cursor
    useEffect(() => {
        if (editorIzquierdaRef.current && (editorIzquierdaRef.current.innerHTML !== contenidoIzquierda)) {
            // Solo actualizar si es diferente para evitar saltos, pero si está vacío y hay contenido, forzarlo
            if (contenidoIzquierda && editorIzquierdaRef.current.innerHTML === '') {
                editorIzquierdaRef.current.innerHTML = contenidoIzquierda;
            } else if (editorIzquierdaRef.current.innerHTML !== contenidoIzquierda) {
                editorIzquierdaRef.current.innerHTML = contenidoIzquierda;
            }
        }
    }, [contenidoIzquierda, editoresReady, activeTab]);

    useEffect(() => {
        if (editorCentroRef.current && (editorCentroRef.current.innerHTML !== contenidoCentro)) {
            if (contenidoCentro && editorCentroRef.current.innerHTML === '') {
                editorCentroRef.current.innerHTML = contenidoCentro;
            } else if (editorCentroRef.current.innerHTML !== contenidoCentro) {
                editorCentroRef.current.innerHTML = contenidoCentro;
            }
        }
    }, [contenidoCentro, editoresReady, activeTab]);

    useEffect(() => {
        if (editorDerechaRef.current && (editorDerechaRef.current.innerHTML !== contenidoDerecha)) {
            if (contenidoDerecha && editorDerechaRef.current.innerHTML === '') {
                editorDerechaRef.current.innerHTML = contenidoDerecha;
            } else if (editorDerechaRef.current.innerHTML !== contenidoDerecha) {
                editorDerechaRef.current.innerHTML = contenidoDerecha;
            }
        }
    }, [contenidoDerecha, editoresReady, activeTab]);

    // Funciones para manejar imágenes (insertar en editores simples)
    const agregarImagenIzquierda = (files) => {
        if (files && files[0]) {
            procesarImagen(files[0], canvasIzquierdaRef, 'izquierda');
        }
    };

    const agregarImagenCentro = (files) => {
        if (files && files[0]) {
            procesarImagen(files[0], canvasCentroRef, 'centro');
        }
    };

    const agregarImagenDerecha = (files) => {
        if (files && files[0]) {
            procesarImagen(files[0], canvasDerechaRef, 'derecha');
        }
    };

    const procesarImagen = (file, canvasRef, columna) => {
        const f = URL.createObjectURL(file);
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const img = new Image();

        img.onload = function () {
            // Obtener tamaño seleccionado por el usuario
            let tamañoSeleccionado = 'normal';
            if (columna === 'izquierda') {
                tamañoSeleccionado = tamañoImagenIzquierda;
            } else if (columna === 'centro') {
                tamañoSeleccionado = tamañoImagenCentro;
            } else if (columna === 'derecha') {
                tamañoSeleccionado = tamañoImagenDerecha;
            }

            // Definir tamaños según la selección del usuario
            let maxWidth, maxHeight;

            switch (tamañoSeleccionado) {
                case 'pequeño':
                    maxWidth = columna === 'centro' ? 120 : 100;
                    maxHeight = columna === 'centro' ? 60 : 50;
                    break;
                case 'normal':
                    maxWidth = columna === 'centro' ? 180 : 150;
                    maxHeight = columna === 'centro' ? 90 : 80;
                    break;
                case 'grande':
                    maxWidth = columna === 'centro' ? 240 : 200;
                    maxHeight = columna === 'centro' ? 120 : 100;
                    break;
                default:
                    maxWidth = columna === 'centro' ? 180 : 150;
                    maxHeight = columna === 'centro' ? 90 : 80;
            }

            // Escalar imagen manteniendo proporciones para que se vea completa
            const imagenEscalada = escalarImagen(img.width, img.height, maxWidth, maxHeight);

            // Ajustar canvas al tamaño de la imagen escalada para evitar cortes
            canvasRef.current.width = imagenEscalada.ancho;
            canvasRef.current.height = imagenEscalada.alto;

            // Dibujar imagen completa sin recortes con alta calidad
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(img, 0, 0, imagenEscalada.ancho, imagenEscalada.alto);

            const imagenBase64 = canvasRef.current.toDataURL();

            // Generar HTML para la imagen
            const htmlImagen = `<img src="${imagenBase64}" style="max-width: ${maxWidth}px; max-height: ${maxHeight}px; width: auto; height: auto; display: inline-block; vertical-align: middle; object-fit: contain;" alt="Imagen ${columna} (${tamañoSeleccionado})" />`;

            // Insertar imagen en el editor
            let editorRef = null;
            if (columna === 'izquierda') {
                editorRef = editorIzquierdaRef.current;
            } else if (columna === 'centro') {
                editorRef = editorCentroRef.current;
            } else if (columna === 'derecha') {
                editorRef = editorDerechaRef.current;
            }

            if (editorRef) {
                editorRef.focus();
                document.execCommand('insertHTML', false, htmlImagen);

                // Actualizar el estado
                const nuevoContenido = editorRef.innerHTML;
                handleEncabezadoChange(columna, nuevoContenido);
            }

            // Restaurar tamaño original del canvas
            canvasRef.current.width = 200;
            canvasRef.current.height = 100;
        };

        img.src = f;
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Aquí puedes implementar la subida del archivo
            // Por ahora, simularemos con una URL
            const reader = new FileReader();
            reader.onload = (event) => {
                handleEncabezadoChange('logo_url', event.target.result);
            };
            reader.readAsDataURL(file);
        }
    };


    const handleToastMsg = (msg) => {
        setShowToast(true);

        setTimeout(() => { setShowToast(false); }, 3000);
    }


    if (loggedIn) {
        return (
            <>
                {/* Estilos CSS para Editores Simples */}
                <style jsx>{`
                    .editor-simple-container {
                        border: 1px solid #ced4da;
                        border-radius: 0.25rem;
                        background: white;
                    }
                    
                    .editor-toolbar {
                        padding: 8px;
                        border-bottom: 1px solid #e9ecef;
                        background: #f8f9fa;
                        border-radius: 0.25rem 0.25rem 0 0;
                    }
                    
                    .editor-content {
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                        resize: vertical;
                        line-height: 1.4;
                    }
                    
                    .editor-content:focus {
                        border: none !important;
                        box-shadow: none !important;
                    }
                    
                    .editor-content p {
                        margin: 0 0 8px 0;
                        line-height: 1.4;
                    }
                    
                    .editor-content p:last-child {
                        margin-bottom: 0;
                    }
                    
                    .editor-content ul, 
                    .editor-content ol {
                        margin: 0 0 8px 20px;
                        padding: 0;
                    }
                    
                    .editor-content li {
                        margin: 2px 0;
                    }
                    
                    .editor-content img {
                        max-width: 100%;
                        height: auto;
                        display: inline-block;
                        vertical-align: middle;
                        object-fit: contain;
                    }
                    
                    .editor-content[contenteditable]:empty:before {
                        content: attr(placeholder);
                        color: #6c757d;
                        font-style: italic;
                    }
                    
                    /* Estilos responsivos para móvil */
                    @media (max-width: 768px) {
                        .encabezado-columns-container {
                            overflow-x: auto;
                            -webkit-overflow-scrolling: touch;
                            padding-bottom: 10px;
                        }
                        
                        .encabezado-columns-container .row {
                            min-width: 900px; /* Ancho mínimo para 3 columnas */
                            flex-wrap: nowrap !important;
                        }
                        
                        .encabezado-columns-container .col-md-4 {
                            flex: 0 0 280px !important;
                            min-width: 280px !important;
                            max-width: 280px !important;
                        }
                        
                        .editor-content {
                            min-height: 100px !important;
                        }
                        
                        .editor-toolbar {
                            padding: 6px;
                        }
                        
                        .btn-group-sm .btn {
                            padding: 0.25rem 0.4rem;
                            font-size: 0.75rem;
                        }
                        
                        .color-buttons-container {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 3px;
                        }
                        
                        .color-button {
                            width: 20px !important;
                            height: 20px !important;
                            min-width: 20px !important;
                            padding: 0 !important;
                            margin: 0 !important;
                        }
                    }
                    
                    @media (max-width: 576px) {
                        .encabezado-columns-container .row {
                            min-width: 800px;
                            flex-wrap: nowrap !important;
                        }
                        
                        .encabezado-columns-container .col-md-4 {
                            flex: 0 0 250px !important;
                            min-width: 250px !important;
                            max-width: 250px !important;
                        }
                        
                        .editor-content {
                            min-height: 80px !important;
                            font-size: 14px;
                        }
                    }
                `}</style>

                <div className="hold-transition">
                    <Header client={client} />
                    <Aside client={client} activelink="profile" />

                    <div className="content-wrapper">
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-8">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item" key="k0"><Link to="/home">Home</Link></li>
                                            <li className="breadcrumb-item" key="k1">Opciones Personales</li>
                                        </ol>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-sm-8">
                                        <h1 className="m-0">Opciones Personales</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="content" >
                            <div className="container-fluid">

                                <div className="row">
                                    <div className="col-md-12">

                                        <div className="card">
                                            <div className="card-header p-2">
                                                <ul className="nav nav-pills nav-pills-configuracion">
                                                    <li className="nav-item" key={'tab1'}>
                                                        <button
                                                            className={`nav-link ${activeTab === 'perfil' ? 'active' : ''}`}
                                                            onClick={() => setActiveTab('perfil')}
                                                            type="button"
                                                        >
                                                            Mi perfil
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" key={'tab2'}>
                                                        <button
                                                            className={`nav-link ${activeTab === 'agenda' ? 'active' : ''}`}
                                                            onClick={() => setActiveTab('agenda')}
                                                            type="button"
                                                        >
                                                            Agenda
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" key={'tab3'}>
                                                        <button
                                                            className={`nav-link ${activeTab === 'encabezado' ? 'active' : ''}`}
                                                            onClick={() => setActiveTab('encabezado')}
                                                            type="button"
                                                        >
                                                            Encabezado
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" key={'tab4'}>
                                                        <button
                                                            className={`nav-link ${activeTab === 'actividad' ? 'active' : ''}`}
                                                            onClick={() => setActiveTab('actividad')}
                                                            type="button"
                                                        >
                                                            Actividad
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="card-body">
                                                <div className="tab-content">
                                                    {activeTab === 'agenda' && (
                                                        <div className="tab-pane active">
                                                            <form id="role-form" onSubmit={handleSubmitParametrosAgenda}>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="form-group">
                                                                            <label>Duración Por Defecto De Las Citas (minutos)</label>
                                                                            <input type="number" min="10" max="120" className="form-control" defaultValue={duracionCita} onChange={(e) => setDuracionCita(e.target.value)} />
                                                                            <div className="invalid-feedback visible">
                                                                                {errorlist.duracion_cita}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <button type="submit" className="btn btn-primary">
                                                                            Guardar Cambios&nbsp;
                                                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    )}

                                                    {activeTab === 'encabezado' && (
                                                        <div className="tab-pane active">
                                                            <div className="alert alert-info">
                                                                <i className="fas fa-info-circle mr-2"></i>
                                                                <strong>Encabezado Personalizado v3.0 - Editor Simple</strong> - Editor visual con colores que funcionan perfectamente.
                                                                Usa los botones de formato y colores, y los botones "Insertar Imagen" para agregar logos.
                                                                <br />
                                                                <small className="mt-2 d-block">
                                                                    <i className="fas fa-lightbulb mr-1"></i>
                                                                    <strong>Tip:</strong> Selecciona texto y haz clic en un color para cambiarlo.
                                                                    Las imágenes se ajustan automáticamente al tamaño seleccionado.
                                                                </small>
                                                            </div>

                                                            <form onSubmit={handleSubmitEncabezado}>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        {!encabezadoExiste ? (
                                                                            <div className="alert alert-success">
                                                                                <i className="fas fa-magic mr-2"></i>
                                                                                <strong>¡Nuevo Sistema!</strong> Crea tu encabezado con 3 columnas flexibles:
                                                                                Izquierda (30%), Centro (40%), Derecha (30%). Máximo 5 líneas por columna.
                                                                            </div>
                                                                        ) : (
                                                                            <div className="alert alert-success">
                                                                                <i className="fas fa-check-circle mr-2"></i>
                                                                                <strong>Encabezado configurado</strong> - Modifica las columnas y guarda los cambios.
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>Nombre del Encabezado *</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={encabezado?.nombre_encabezado || ''}
                                                                                onChange={(e) => handleEncabezadoChange('nombre_encabezado', e.target.value)}
                                                                                placeholder="Ej: Encabezado Clínica Principal"
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>Estado</label>
                                                                            <select
                                                                                className="form-control"
                                                                                value={encabezado?.estado || 1}
                                                                                onChange={(e) => handleEncabezadoChange('estado', parseInt(e.target.value))}
                                                                            >
                                                                                <option value={1}>Habilitado</option>
                                                                                <option value={0}>Deshabilitado</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="encabezado-columns-container">
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <i className="fas fa-align-left mr-1"></i>
                                                                                    Columna Izquierda (30%)
                                                                                </label>

                                                                                {/* Editor Simple - Columna Izquierda */}
                                                                                {editoresReady ? (
                                                                                    <div className="editor-simple-container">
                                                                                        <div className="editor-toolbar mb-2">
                                                                                            <div className="btn-group btn-group-sm" role="group">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'bold')}
                                                                                                    title="Negrita"
                                                                                                >
                                                                                                    <i className="fas fa-bold"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'italic')}
                                                                                                    title="Cursiva"
                                                                                                >
                                                                                                    <i className="fas fa-italic"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'underline')}
                                                                                                    title="Subrayado"
                                                                                                >
                                                                                                    <i className="fas fa-underline"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'insertUnorderedList')}
                                                                                                    title="Lista"
                                                                                                >
                                                                                                    <i className="fas fa-list-ul"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            ref={editorIzquierdaRef}
                                                                                            className="editor-content form-control"
                                                                                            contentEditable={true}
                                                                                            style={{ minHeight: '120px', padding: '10px' }}
                                                                                            suppressContentEditableWarning={true}
                                                                                            onInput={(e) => handleContenidoChange('izquierda', e.target.innerHTML)}
                                                                                            placeholder="Escribe el contenido para la columna izquierda..."
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="alert alert-info">
                                                                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                                                                        Cargando editor...
                                                                                    </div>
                                                                                )}

                                                                                {/* Canvas oculto para procesar imagen */}
                                                                                <canvas
                                                                                    ref={canvasIzquierdaRef}
                                                                                    width="200"
                                                                                    height="100"
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Input file oculto */}
                                                                                <input
                                                                                    type="file"
                                                                                    id="imagenIzquierda"
                                                                                    accept=".jpg,.png,.jpeg"
                                                                                    onChange={(e) => agregarImagenIzquierda(e.target.files)}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Selector de tamaño de imagen */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-expand-arrows-alt mr-1"></i>
                                                                                        Tamaño de imagen:
                                                                                    </small>
                                                                                    <select
                                                                                        className="form-control form-control-sm"
                                                                                        value={tamañoImagenIzquierda}
                                                                                        onChange={(e) => setTamañoImagenIzquierda(e.target.value)}
                                                                                    >
                                                                                        <option value="pequeño">Pequeño (100x50px)</option>
                                                                                        <option value="normal">Normal (150x80px)</option>
                                                                                        <option value="grande">Grande (200x100px)</option>
                                                                                    </select>
                                                                                </div>

                                                                                {/* Botón para cargar imagen */}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-success btn-sm mt-2 w-100"
                                                                                    onClick={() => document.getElementById('imagenIzquierda').click()}
                                                                                >
                                                                                    <i className="fas fa-image mr-2"></i>
                                                                                    Insertar Imagen ({tamañoImagenIzquierda})
                                                                                </button>

                                                                                {/* Botones de colores */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-palette mr-1"></i>
                                                                                        Colores de texto:
                                                                                    </small>
                                                                                    <div className="color-buttons-container">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#000000', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#000000')}
                                                                                            title="Negro"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#dc3545', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#dc3545')}
                                                                                            title="Rojo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#007bff', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#007bff')}
                                                                                            title="Azul"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#28a745', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#28a745')}
                                                                                            title="Verde"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#ffc107', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#ffc107')}
                                                                                            title="Amarillo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#6f42c1', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#6f42c1')}
                                                                                            title="Morado"
                                                                                        ></button>
                                                                                    </div>
                                                                                </div>

                                                                                <small className="form-text text-muted mt-2">
                                                                                    <i className="fas fa-info-circle mr-1"></i>
                                                                                    <strong>Colores:</strong> Selecciona texto y haz clic en un color - ¡funciona con document.execCommand!
                                                                                    <br />
                                                                                    <strong>Imágenes:</strong> Elige el tamaño y haz clic en "Insertar Imagen".
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <i className="fas fa-align-center mr-1"></i>
                                                                                    Columna Centro (40%)
                                                                                </label>

                                                                                {/* Editor Simple - Columna Centro */}
                                                                                {editoresReady ? (
                                                                                    <div className="editor-simple-container">
                                                                                        <div className="editor-toolbar mb-2">
                                                                                            <div className="btn-group btn-group-sm" role="group">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'bold')}
                                                                                                    title="Negrita"
                                                                                                >
                                                                                                    <i className="fas fa-bold"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'italic')}
                                                                                                    title="Cursiva"
                                                                                                >
                                                                                                    <i className="fas fa-italic"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'underline')}
                                                                                                    title="Subrayado"
                                                                                                >
                                                                                                    <i className="fas fa-underline"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'insertUnorderedList')}
                                                                                                    title="Lista"
                                                                                                >
                                                                                                    <i className="fas fa-list-ul"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            ref={editorCentroRef}
                                                                                            className="editor-content form-control"
                                                                                            contentEditable={true}
                                                                                            style={{ minHeight: '120px', padding: '10px' }}
                                                                                            suppressContentEditableWarning={true}
                                                                                            onInput={(e) => handleContenidoChange('centro', e.target.innerHTML)}
                                                                                            placeholder="Escribe el contenido para la columna centro..."
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="alert alert-info">
                                                                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                                                                        Cargando editor...
                                                                                    </div>
                                                                                )}

                                                                                {/* Canvas oculto para procesar imagen */}
                                                                                <canvas
                                                                                    ref={canvasCentroRef}
                                                                                    width="200"
                                                                                    height="100"
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Input file oculto */}
                                                                                <input
                                                                                    type="file"
                                                                                    id="imagenCentro"
                                                                                    accept=".jpg,.png,.jpeg"
                                                                                    onChange={(e) => agregarImagenCentro(e.target.files)}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Selector de tamaño de imagen */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-expand-arrows-alt mr-1"></i>
                                                                                        Tamaño de imagen:
                                                                                    </small>
                                                                                    <select
                                                                                        className="form-control form-control-sm"
                                                                                        value={tamañoImagenCentro}
                                                                                        onChange={(e) => setTamañoImagenCentro(e.target.value)}
                                                                                    >
                                                                                        <option value="pequeño">Pequeño (120x60px)</option>
                                                                                        <option value="normal">Normal (180x90px)</option>
                                                                                        <option value="grande">Grande (240x120px)</option>
                                                                                    </select>
                                                                                </div>

                                                                                {/* Botón para cargar imagen */}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-success btn-sm mt-2 w-100"
                                                                                    onClick={() => document.getElementById('imagenCentro').click()}
                                                                                >
                                                                                    <i className="fas fa-image mr-2"></i>
                                                                                    Insertar Imagen ({tamañoImagenCentro})
                                                                                </button>

                                                                                {/* Botones de colores */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-palette mr-1"></i>
                                                                                        Colores de texto:
                                                                                    </small>
                                                                                    <div className="color-buttons-container">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#000000', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#000000')}
                                                                                            title="Negro"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#dc3545', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#dc3545')}
                                                                                            title="Rojo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#007bff', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#007bff')}
                                                                                            title="Azul"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#28a745', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#28a745')}
                                                                                            title="Verde"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#ffc107', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#ffc107')}
                                                                                            title="Amarillo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#6f42c1', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#6f42c1')}
                                                                                            title="Morado"
                                                                                        ></button>
                                                                                    </div>
                                                                                </div>

                                                                                <small className="form-text text-muted mt-2">
                                                                                    <i className="fas fa-hospital mr-1"></i>
                                                                                    Información principal de la clínica con formato profesional.
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <i className="fas fa-align-right mr-1"></i>
                                                                                    Columna Derecha (30%)
                                                                                </label>

                                                                                {/* Editor Simple - Columna Derecha */}
                                                                                {editoresReady ? (
                                                                                    <div className="editor-simple-container">
                                                                                        <div className="editor-toolbar mb-2">
                                                                                            <div className="btn-group btn-group-sm" role="group">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'bold')}
                                                                                                    title="Negrita"
                                                                                                >
                                                                                                    <i className="fas fa-bold"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'italic')}
                                                                                                    title="Cursiva"
                                                                                                >
                                                                                                    <i className="fas fa-italic"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'underline')}
                                                                                                    title="Subrayado"
                                                                                                >
                                                                                                    <i className="fas fa-underline"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'insertUnorderedList')}
                                                                                                    title="Lista"
                                                                                                >
                                                                                                    <i className="fas fa-list-ul"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            ref={editorDerechaRef}
                                                                                            className="editor-content form-control"
                                                                                            contentEditable={true}
                                                                                            style={{ minHeight: '120px', padding: '10px' }}
                                                                                            suppressContentEditableWarning={true}
                                                                                            onInput={(e) => handleContenidoChange('derecha', e.target.innerHTML)}
                                                                                            placeholder="Escribe el contenido para la columna derecha..."
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="alert alert-info">
                                                                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                                                                        Cargando editor...
                                                                                    </div>
                                                                                )}

                                                                                {/* Canvas oculto para procesar imagen */}
                                                                                <canvas
                                                                                    ref={canvasDerechaRef}
                                                                                    width="200"
                                                                                    height="100"
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Input file oculto */}
                                                                                <input
                                                                                    type="file"
                                                                                    id="imagenDerecha"
                                                                                    accept=".jpg,.png,.jpeg"
                                                                                    onChange={(e) => agregarImagenDerecha(e.target.files)}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Selector de tamaño de imagen */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-expand-arrows-alt mr-1"></i>
                                                                                        Tamaño de imagen:
                                                                                    </small>
                                                                                    <select
                                                                                        className="form-control form-control-sm"
                                                                                        value={tamañoImagenDerecha}
                                                                                        onChange={(e) => setTamañoImagenDerecha(e.target.value)}
                                                                                    >
                                                                                        <option value="pequeño">Pequeño (100x50px)</option>
                                                                                        <option value="normal">Normal (150x80px)</option>
                                                                                        <option value="grande">Grande (200x100px)</option>
                                                                                    </select>
                                                                                </div>

                                                                                {/* Botón para cargar imagen */}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-success btn-sm mt-2 w-100"
                                                                                    onClick={() => document.getElementById('imagenDerecha').click()}
                                                                                >
                                                                                    <i className="fas fa-image mr-2"></i>
                                                                                    Insertar Imagen ({tamañoImagenDerecha})
                                                                                </button>

                                                                                {/* Botones de colores */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-palette mr-1"></i>
                                                                                        Colores de texto:
                                                                                    </small>
                                                                                    <div className="d-flex flex-wrap">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#000000', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#000000')}
                                                                                            title="Negro"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#dc3545', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#dc3545')}
                                                                                            title="Rojo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#007bff', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#007bff')}
                                                                                            title="Azul"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#28a745', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#28a745')}
                                                                                            title="Verde"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#ffc107', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#ffc107')}
                                                                                            title="Amarillo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#6f42c1', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#6f42c1')}
                                                                                            title="Morado"
                                                                                        ></button>
                                                                                    </div>
                                                                                </div>

                                                                                <small className="form-text text-muted mt-2">
                                                                                    <i className="fas fa-receipt mr-1"></i>
                                                                                    Datos adicionales, fechas, números de factura.
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Vista previa del encabezado */}
                                                                {(encabezado?.nombre_encabezado || encabezado?.izquierda || encabezado?.centro || encabezado?.derecha) && (
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <div className="card card-outline card-info">
                                                                                <div className="card-header">
                                                                                    <h3 className="card-title">
                                                                                        <i className="fas fa-eye mr-2"></i>Vista Previa del Encabezado
                                                                                    </h3>
                                                                                </div>
                                                                                <div className="card-body">
                                                                                    <div style={{
                                                                                        display: 'flex',
                                                                                        width: '100%',
                                                                                        minHeight: '60px',
                                                                                        backgroundColor: '#f8f9fa',
                                                                                        overflow: 'hidden'
                                                                                    }}>
                                                                                        {/* Columna Izquierda - 30% */}
                                                                                        <div style={{
                                                                                            flex: '0 0 30%',
                                                                                            padding: '2px',
                                                                                            borderRight: '1px solid #dee2e6',
                                                                                            fontSize: '10px',
                                                                                            lineHeight: '1.1',
                                                                                            verticalAlign: 'top',
                                                                                            wordWrap: 'break-word',
                                                                                            overflowWrap: 'break-word'
                                                                                        }}>
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: encabezado?.izquierda || '<em>Columna izquierda vacía</em>'
                                                                                            }} />
                                                                                        </div>

                                                                                        {/* Columna Centro - 40% */}
                                                                                        <div style={{
                                                                                            flex: '0 0 40%',
                                                                                            padding: '2px',
                                                                                            borderRight: '1px solid #dee2e6',
                                                                                            textAlign: 'center',
                                                                                            fontSize: '11px',
                                                                                            lineHeight: '1.1',
                                                                                            verticalAlign: 'top',
                                                                                            wordWrap: 'break-word',
                                                                                            overflowWrap: 'break-word'
                                                                                        }}>
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: encabezado?.centro || '<em>Columna centro vacía</em>'
                                                                                            }} />
                                                                                        </div>

                                                                                        {/* Columna Derecha - 30% */}
                                                                                        <div style={{
                                                                                            flex: '0 0 30%',
                                                                                            padding: '2px',
                                                                                            textAlign: 'right',
                                                                                            fontSize: '10px',
                                                                                            lineHeight: '1.1',
                                                                                            verticalAlign: 'top',
                                                                                            wordWrap: 'break-word',
                                                                                            overflowWrap: 'break-word'
                                                                                        }}>
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: encabezado?.derecha || '<em>Columna derecha vacía</em>'
                                                                                            }} />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="mt-2">
                                                                                        <small className="text-muted">
                                                                                            <i className="fas fa-info-circle mr-1"></i>
                                                                                            Esta vista previa muestra cómo se verá el encabezado en documentos PDF e impresiones.
                                                                                        </small>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <button type="submit" className="btn btn-primary">
                                                                            <i className="fas fa-save mr-2"></i>
                                                                            {encabezadoExiste ? 'Actualizar' : 'Guardar'} Encabezado&nbsp;
                                                                            {loadingEncabezado && (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)}
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="alert alert-success mb-0">
                                                                            <small>
                                                                                <i className="fas fa-user-md mr-1"></i>
                                                                                <strong>Para Profesionales:</strong> Usa los botones del editor (negrita, cursiva, tamaños) para formatear texto. Los botones verdes insertan imágenes automáticamente.
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    )}

                                                    {activeTab === 'actividad' && (
                                                        <div className="tab-pane active">
                                                            <h3>Actividad</h3>
                                                        </div>
                                                    )}

                                                    {activeTab === 'perfil' && (
                                                        <div className="tab-pane active">
                                                            <Perfil2 toastMsg={handleToastMsg} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                    <Footer showToast={showToast} message={toastMsg} />
                </div>
            </>
        );
    }

    return (
        <Loading />
    );
}
export default Configuracion;